var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16300_100297)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81.6,
    height: 81.6,
    rx: 40.8,
    fill: "#4F46E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8 81.6C63.3332 81.6 81.6 63.3332 81.6 40.8C81.6 18.2668 63.3332 0 40.8 0C18.2668 0 0 18.2668 0 40.8C0 63.3332 18.2668 81.6 40.8 81.6ZM38.529 26.3566C36.964 25.3132 34.9518 25.216 33.2935 26.1035C31.6352 26.991 30.6 28.7192 30.6 30.6V51C30.6 52.8809 31.6352 54.6091 33.2935 55.4966C34.9518 56.384 36.964 56.2868 38.529 55.2435L53.829 45.0435C55.2478 44.0976 56.1 42.5052 56.1 40.8C56.1 39.0948 55.2478 37.5024 53.829 36.5566L38.529 26.3566Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16300_100297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81.6,
    height: 81.6,
    rx: 40.8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.75b1966ab753a299c62fb6c7e73f9b82.svg";
export { ForwardRef as ReactComponent };